import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  CircularProgress,
} from '@mui/material';
import { type CalibreEditDialogProps } from '../types/especie';
import { useCalibreForm } from '../hooks/useCalibreForm';

export const EditCalibre: React.FC<CalibreEditDialogProps> = ({
  open,
  calibreId,
  idPresentacion,
  onClose,
  onSave,
  title = 'Editar Calibre',
}) => {
  const {
    formData,
    errors,
    loading,
    isValid,
    handleChange,
    handleSubmit,
    resetForm,
  } = useCalibreForm(calibreId, idPresentacion, onSave);

  React.useEffect(() => {
    if (open && !calibreId) {
      resetForm();
    }
  }, [open, calibreId, resetForm]);

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleSubmit();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        component: 'form',
        onSubmit: handleFormSubmit,
      }}
    >
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <TextField
            label="Descripción"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            error={!!errors.descripcion}
            helperText={errors.descripcion}
            required
            fullWidth
            autoFocus
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          type="submit"
          variant="contained"
          disabled={!isValid || loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? 'Guardando...' : 'Guardar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};